

export default [
  {
    description: 'Etiqueta Gandola (A4)',
    template: '<div data-v-fcc51e34="" class="row e" style="margin-left: 1%; margin-top: 0.2%; font-size: 12pt; font-weight: bold; overflow-wrap: break-word;"> @descricao </div><div data-v-fcc51e34="" class="d-flex row mt-2"><div data-v-fcc51e34="" class="col text-center" style="margin-left: 1%; margin-top: 0%; font-size: 9pt; font-weight: bold;"> À Vista R$@precoAV </div><div data-v-fcc51e34="" class="col text-center" style="margin-left: 1%; margin-top: 0%; font-size: 9pt; font-weight: bold;"> À Prazo R$@precoPZ </div></div><div data-v-fcc51e34="" class="d-flex col justify-start"><small data-v-fcc51e34=""> @codigo </small></div>',
    pageParams: {
      itensPerPage: 24,
      pageHeight: 29.7,
      pageWidth: 21,
      padding: 0.5,
      margin: 0.5,
      alignment: 'center',
    },
    tagParams: {
      height: 3,
      width: 6,
    }
  },
  {
    description: 'Etiqueta Termica (6x4)',
    template: '<div data-v-fcc51e34="" class="row e" style="margin-left: 1%; margin-top: 0.2%; font-size: 12pt; font-weight: bold; overflow-wrap: break-word;"> @descricao </div><div data-v-fcc51e34="" class="d-flex row mt-2"><div data-v-fcc51e34="" class="col text-center" style="margin-left: 1%; margin-top: 0%; font-size: 9pt; font-weight: bold;"> À Vista R$@precoAV </div><div data-v-fcc51e34="" class="col text-center" style="margin-left: 1%; margin-top: 0%; font-size: 9pt; font-weight: bold;"> À Prazo R$@precoPZ </div></div><div data-v-fcc51e34="" class="d-flex col justify-start"><small data-v-fcc51e34=""> @codigo </small></div>',
    pageParams: {
      itensPerPage: 1,
      pageHeight: 4,
      pageWidth: 6,
      padding: 0,
      margin: 0,
      alignment: 'center',
    },
    tagParams: {
      height: 4,
      width: 6,
    }
  },


]


